import type { Currencies } from '@s4l/stayforlong/kernel/Currency'

export interface InsuranceQuote {
  quoteId: string
  insuranceTypeId: BattlefaceInsuranceType
  amount: number
  currency: Currencies
  highlighted?: boolean
}

export interface InsuranceQuotes {
  [availabilityId: string]: InsuranceQuote[]
}

export type InsuranceQuotesResponse = InsuranceQuotes | []

export type BattlefaceType = (typeof BATTLEFACE_TYPES)[keyof typeof BATTLEFACE_TYPES]

export type BattlefaceInsuranceType =
  (typeof BATTLEFACE_INSURANCE_TYPES)[keyof typeof BATTLEFACE_INSURANCE_TYPES]

export const BATTLEFACE_INSURANCE_NAME = 'battleface'

export const BATTLEFACE_TYPES = {
  essential: 'tripCancellation',
  advanced: 'base',
  complete: 'comprehensive',
} as const

export const BATTLEFACE_INSURANCE_TYPES = {
  essentialDomestic: 'battleface_tripCancellation_domestic',
  essentialEu: 'battleface_tripCancellation_eu',
  essentialUsaCanadaCaribbean: 'battleface_tripCancellation_usaCanadaCaribbean',
  essentialWorld: 'battleface_tripCancellation_world',

  advancedDomestic: 'battleface_base_domestic',
  advancedEu: 'battleface_base_eu',
  advancedUsaCanadaCaribbean: 'battleface_base_usaCanadaCaribbean',
  advancedWorld: 'battleface_base_world',

  completeDomestic: 'battleface_comprehensive_domestic',
  completeEu: 'battleface_comprehensive_eu',
  completeUsaCanadaCaribbean: 'battleface_comprehensive_usaCanadaCaribbean',
  completeWorld: 'battleface_comprehensive_world',
} as const
